export default __webpack_public_path__ + "static/media/gif.c0f83497.png";